import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions'
import { ModalButton } from '../../../components/ModalButton'
import { Modal } from '../../../components/Modal'
import { ScrollListView } from '../../../components/ScrollListView'
import { GranitePreviewCard } from './GranitePreviewCard'
import { GraniteCarousel } from './GraniteCarousel'
import { FgraniteColors } from '../../family/FgraniteColors'
import * as _ from 'lodash'
import eventBus from '../../../services/EventBus'
import ElemConfirm from '../../../components/ElemConfirm'
import * as apiService from "../../../services/api.service";
import {userCan, getOrganization} from '../../../services/userRights.service';
import {defaultBicolorGranites, initializeIconColor, configurationOrdered} from '../../../services/utils.service'
import cn from 'classnames';
import { isConfigRequested } from "../../../services/configurationWarningChecks"
import { gtmFamily } from '../../../services/gtmFamily';
import { TranslationContext } from "../../../context/TranslationContext";
import { resetLazyImageQueue } from '../../../components/LazyImage';
import { gtmPro } from "../../../services/gtmPro";
import { getconfigprices } from '../../helpers/pricesHelper';
import {isQuote} from '../../../services/restrictedConfiguration';

/**
 * ModalButton permettant de choisir le granite pour tout le monument
 */
class GlobalGranitePickerComponent extends Component {
  static contextType = TranslationContext;
  currentAvailableGranites = [];
  previousAvailableGranites = [];
  state = {
    selectedIndex: 0,
    pictos: [],
    currentFilter: null,
    currentFilterSearch: null,
    showConfirm: false,
    fromMatchingColor: false,
    selectedGranite: null,
    defaultgranites: [],
    filtredGranites: false,
    resetFilter: false,
    maxgranites: 0,
    _granite: {},
    _isMounted: false,
    isallgranites: false,
    filter_list: [],
    color: "",
    showImage: true,
    filterValue: {
      recherche: null,
      couleur: null
    },
    // 👇 add these
    currentPage: 0,
    loadingPrices: false,
    hasMorePrices: true,
    // Price batches
    prices: {},
    pricePage: 0,
    loadingPriceBatches: [],
    initialPricesLoaded: false,
    showSellingPrices: false,
  }

  modal
  granites = this.props.granites.map((r) => ({
    ...r,
    showConfirm: false
  }))

  loadPrices = async (availableGranites) => {
    const { prices, loadingPrices, showSellingPrices } = this.state;

    if (isQuote(this.props.configuration) || configurationOrdered(this.props.configuration)) {
      return
    }
    if (loadingPrices || !availableGranites?.length) {
      return;
    }
    if (!showSellingPrices) {
      return;
    }
    const { configuration } = this.props;
    const granitesWithoutPrice = availableGranites.filter((granite) => {
      if (!granite || granite.reference === 0) {
        return false;
      }

      const key = this.getPriceKey(
        configuration.reference,
        granite.reference,
        granite.gs?.reference || "",
        configuration.updatedAt

      );

      return prices[key] === undefined;
    });

    // Load only 20 missing prices at a time
    const granites = granitesWithoutPrice.slice(0, 20);

    if (!granites.length) {
      return;
    }

    this.setState({ loadingPrices: true });

    try {
      const configurations = granites.map((granite) =>
        this.buildGraniteConfiguration(configuration, granite)
      );

      const data = await getconfigprices(configurations);

      const newPrices = {};

      data.forEach((res, index) => {
        const granite = granites[index];

        if (!granite) {
          return;
        }

        const key = this.getPriceKey(
          configuration.reference,
          granite.reference,
          granite.gs?.reference || "",
          configuration.updatedAt
        );

        newPrices[key] = res.price?.selling;
      });

      this.setState((prevState) => ({
        prices: {
          ...prevState.prices,
          ...newPrices,
        },
        loadingPrices: false,
      }));
    } catch (error) {
      console.error("Error loading granite prices:", error);
      this.setState({
        loadingPrices: false,
      });
    }
  };

  buildGraniteConfiguration = (configuration, granite) => {
    const oldGranite = configuration.monument.graniteMain;
    const oldGraniteSecondary =
      configuration.monument.graniteSecondary || "";

    const graniteMain = granite.reference;
    const graniteSecondary = granite.gs?.reference || "";

    const getGranite = (currentGranite) => {
      if (currentGranite === oldGranite || currentGranite === "") {
        return graniteMain;
      }

      if (
        currentGranite === oldGraniteSecondary &&
        configuration.bicolorMonument
      ) {
        return graniteSecondary;
      }

      return currentGranite;
    };

    return {
      ...configuration,

      monument: {
        ...configuration.monument,
        graniteMain,
        graniteSecondary,
      },

      frame: {
        ...configuration.frame,
        granite: getGranite(configuration.frame.granite),
      },

      veneer: {
        ...configuration.veneer,
        granite: getGranite(configuration.veneer.granite),
      },

      accessories: (configuration.accessories || []).map((accessory) => ({
        ...accessory,
        granite: getGranite(accessory.granite),
      })),
    };
  };
  
  componentDidMount = (data) => {
    const {showSellingPrices} = this.state;
    initializeIconColor(showSellingPrices);
    document.querySelector("body").addEventListener("click", this.handleClick,false)
    this.setState({ _isMounted: true })
    eventBus.on('confirm-delete-accessories', (data) => {
      if (data.value.hasOwnProperty('granite')) {
        this.onClickDisableGranite(data.value.granite, data.response)
      }
    })
    if(userCan.granitePicto()) { 
      if(!this.props.family){
        apiService.getExternal(`granitePictos`).then(granitepic=>{
          this.setState({ pictos: granitepic})
        })
      }
    }
    // GTM
    if(this.props.family) {
      const allGranites = _.filter(this.props.granites, 'available')
        .map(g => {
          return {
            reference: g.reference,
            name: g.name,
            price: g.price,
            origin: g.origin,
            color: g.colorGranite
          }
        })
      gtmFamily().customizeConfigurator(
        "configurator.filter",
        "liste granits",
        {
          type: "granit",
          query: "couleur",
          filter: "Toutes les couleurs"
        },
        allGranites
      )
    }
    // end GTM
    const { mainColor } = this.props.adminConfig
    this.setState({ color: mainColor});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // GTM
    if ( this.props.family && this.props.filter !== nextProps.filter) {
      const { filter, granites, configuration } = nextProps
      const { monument } = configuration

      let resGranites = _.filter(granites, 'available')
      resGranites = resGranites
        .filter( g => {
          if (filter == null) {
            return true
          }
          return g.reference === monument.graniteMain || g.colorGranite === filter 
        })
        .map(g => {
          return {
            reference: g.reference,
            name: g.name,
            price: g.price,
            origin: g.origin,
            color: g.colorGranite
          }
        })
      gtmFamily().customizeConfigurator(
        "configurator.filter",
        "liste granits",
        {
          type: "granit",
          query: "couleur",
          filter: filter == null ? "Toutes les couleurs" : filter
        },
        resGranites
      )
    }
    // end GTM
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.family && userCan.seeAndChangeSellingPrices()) {
      const filterChanged =
        prevState.currentFilter !== this.state.currentFilter ||
        prevState.currentFilterSearch !== this.state.currentFilterSearch;

      const currentGranites = this.currentAvailableGranites || [];

      const availableGranitesChanged =
        currentGranites.length !== this.previousAvailableGranites.length ||
        currentGranites.some(
          (granite, index) =>
            granite?.reference !==
              this.previousAvailableGranites[index]?.reference ||
            granite?.gs?.reference !==
              this.previousAvailableGranites[index]?.gs?.reference
        );
      const {showSellingPrices} = this.state;  
      const showSellingPricesChanged =
        prevState.showSellingPrices !== this.state.showSellingPrices;
      if (showSellingPricesChanged) {
        initializeIconColor(showSellingPrices);
      }  

      if (availableGranitesChanged ||
          (showSellingPricesChanged && this.state.showSellingPrices === true)) {
        this.previousAvailableGranites = [...currentGranites];

        this.loadPrices(currentGranites);
      }
    }
    if (
      !this.props.family &&
      this.props.configuration.bicolorMonument &&
      !this.state.defaultgranites.length &&
      this.currentAvailableGranites.length
    ) {
      const { matchcolors } = this.props;

      const defaultGranites = defaultBicolorGranites(
        this.currentAvailableGranites,
        matchcolors
      );

      this.setState({
        defaultgranites: defaultGranites,
        maxgranites: this.currentAvailableGranites.length
      });
    }
  }

  componentWillUnmount() {
    document.querySelector("body").removeEventListener("click", this.handleClick, false)
    this.setState = (state, callback) => {
      return
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { currentFilter, currentFilterSearch, filtredGranites } = this.state;
    if (
      !this.props.family && 
      (
        nextState.currentFilter !== currentFilter ||
        nextState.currentFilterSearch !== currentFilterSearch
      )
    ) {
      const filter = {
        recherche: nextState.currentFilterSearch,
        couleur: nextState.currentFilter
      };
      
      let filtredGranites = true
      if (!nextState.currentFilterSearch && !nextState.currentFilter) {
        filtredGranites = false
        this.setState()
      }
      this.setState({filterValue: filter, filtredGranites: filtredGranites, resetFilter: false, currentFilter: nextState.currentFilter, currentFilterSearch: nextState.currentFilterSearch})
    }
  }

  
  handleClick = (e) => {
    if (!e.target.classList.contains("colorFilter") && !e.target.classList.contains("productColorFilter")) {
      if (document.getElementById("matchingColors")) document.getElementById("matchingColors").style.display = "none"
    }
  }

  onClickDisableGranite = (granite, response) => {
    const index = this.granites.findIndex(
      (r) => r.reference === granite.reference
    )
    if (!this.granites[index].showConfirm) {
      this.granites[index].showConfirm = true
      this.setState({ showConfirm: true, _granite: this.granites[index] })
    } else if (response) {
      this.props.actions.removeAllAccessories()
      this.onSelectGranite(granite)
      this.granites[index].showConfirm = false
      this.setState({ showConfirm: false })
    } else {
      this.granites[index].showConfirm = false
      this.setState({ showConfirm: false })
    }
  }

  onSelectGranite = (granite, index) => {
    const graniteSecondary = granite.gs ? granite.gs.reference : null
    gtmPro().clickGranite(granite, 'monument')
    if (this.props.onSelect) {
      this.props.onSelect(granite)
    } else {
      this.setState({showImage: false}, () => {
        this.props.actions.updateGraniteGlobal(granite.reference,graniteSecondary)
        this.setState({ selectedIndex: index })
        this.modal.close()
        resetLazyImageQueue();
        setTimeout(() => {
          this.setState({showImage: true})
        }, 1000);
      })
      
    }
  }
  findGraniteIndex = (graniteRef, granites) => {
    return granites.findIndex((elt) => elt.reference === graniteRef)
  }
  handleGranitsClick = (granites) => {
    const { monument } = this.props.configuration;
    let gtmName = "extranet.config3d.config3d_granit_button_monument";
    if (monument.category && monument.category.includes("SEM")) {
      gtmName = "extranet.config3d.config3d_granit_button_frame";
    } else if (monument.category && monument.category.includes("PLT")) {
      gtmName = "extranet.config3d.config3d_granit_button_veneer";
    }
    gtmPro().ctaOfConfiguration(
      {
        name: gtmName,
        category: "configurateur",
        subcategory: "Granit",
        type: "cta",
        from: "left"
      },
      {template:"configurateur", subtemplate:"granits"},
      {},
      "partner",
      "product",
      "user",
      "page"
    );
    gtmPro().listGranites(granites)
    if (!this.props.family && !isQuote(this.props.configuration)) {
      const currentGranites = granites || this.currentAvailableGranites || [];

      this.loadPrices(currentGranites);
    }
  };
  availableGranitesFiltred = (theFilter, theFilterSearch, availableGranites) => {
    const {isFamily, configuration} =  this.props
    const { bicolorMonument } = configuration
    if (theFilter) {
      availableGranites = availableGranites.filter(
        (granite) => {
          if (bicolorMonument) {
            const filter = !isFamily && !theFilter.includes("/") ? `${theFilter}/${theFilter}` : theFilter
            if (!isFamily) {
              if (this.state.fromMatchingColor) {
                return granite.colorGranite.includes(filter) && granite.reference === granite.gs.reference
              } else {
                return granite.colorGranite.includes(filter)
              }
            } else {
              return  granite.colorGranite.includes(`${theFilter}/`)
            }
          } else  {
            return granite.colorGranite === theFilter
          }
        }
      )
    }
    if (theFilterSearch) {
      if(bicolorMonument && !isFamily) {
        availableGranites = availableGranites.filter(
          (granite) => {
            const graniteMain = granite.name?.toUpperCase().includes(theFilterSearch.toUpperCase()) || granite.name?.toUpperCase().replace(/É|Ê|È|Ë/g, "E").includes(theFilterSearch.toUpperCase())
            const graniteSecondary = granite.gs?.name?.toUpperCase().includes(theFilterSearch.toUpperCase()) || granite.gs?.name?.toUpperCase().replace(/É|Ê|È|Ë/g, "E").includes(theFilterSearch.toUpperCase())
            return graniteMain || graniteSecondary
          }
        )
      } else {
        availableGranites = availableGranites.filter(
          (granite) => granite.name?.toUpperCase().includes(theFilterSearch.toUpperCase()) || granite.name?.toUpperCase().replace(/É|Ê|È|Ë/g, "E").includes(theFilterSearch.toUpperCase())
        )
      }
    }
    const {currentFilter, currentFilterSearch} = this.state
    const res = this.state.resetFilter && bicolorMonument ? this.state.defaultgranites : availableGranites;
    const filterV = this.state.resetFilter ? {recherche: '', couleur: ''} : this.state.filterValue
    if(this.state.filtredGranites || this.state.resetFilter || (currentFilter === null && currentFilterSearch === null)) {
      gtmPro().listGranites(res, filterV)
    }
    this.currentAvailableGranites = availableGranites;
    
    return availableGranites;  
  }
  handlePlusClick = () =>{
    this.setState({isallgranites: true});
    const { currentFilter } = this.state
    const filter = currentFilter || this.props.filter
    let filters = [];
    if(!this.state.filter_list.includes(filter)){
      filters = this.state.filter_list
      filters.push(filter)
      this.setState({ filter_list: filters})
    }
  }

  onModalClose = () =>{
    this.setState({showImage: false}, () => {
      resetLazyImageQueue();
      this.setState({ currentFilter: null, currentFilterSearch: null, selectedGranite: null });

      setTimeout(() => {
        this.setState({showImage: true})
      }, 1000);
    })
  }

  getPriceKey = (reference, graniteMain, graniteSecondary, updatedAt) => {
    return `${reference}_${graniteMain}_${graniteSecondary || ""}_${updatedAt}`;
  };

  getGranitePrice = (granite) => {
    const { configuration } = this.props;

    const key = this.getPriceKey(
      configuration.reference,
      granite.reference,
      granite.gs?.reference || "",
      configuration.updatedAt
    );

    return this.state.prices[key];
  };

  togllePrice =() =>{
    const show = this.state.showSellingPrices
    this.setState({showSellingPrices: !show})
  }

  renderItem =
    (disabledGranitesByAccessories, availableGranitesByHeadstone = null, t=null) =>
    (granite, index) => {
      const { monument, frame, bicolorMonument } = this.props.configuration

        const showPrice = !this.props.family 
                      && userCan.seeAndChangeSellingPrices()
                      && this.state.showSellingPrices;
        const price = showPrice
                      ? this.getGranitePrice(granite) : null;
        const loadingPrice = showPrice ? price === undefined :null;

      if(granite && granite.reference === 0 && !this.props.family){
        return (
          <div className={cn(["GraniteCard", "GranitePreviewCard"])} style={{background:"#7f7f7f"}} onClick={()=>this.handlePlusClick()}>
            <figure className="LazyImage"></figure>
            <div className="Infos plusGranite"><div><div className="plus">+</div><div>{t("config3d_granit_modal_more_granits") || "Voir plus de granits"}</div></div></div>
          </div>
        );
      }
      const selectedGranite = bicolorMonument && !this.props.family ? (granite && (granite.reference === monument.graniteMain && granite.gs?.reference === monument.graniteSecondary) && index === 0) : (granite && granite.reference === monument.graniteMain)
      const frameGranite = frame && frame.granite !== "" ? frame.granite : 0
      return (granite && this.state.showImage && 
        <GranitePreviewCard
          key={granite?.reference}
          monument={monument}
          pictos={this.state.pictos && this.state.pictos.filter(picto => granite.pictos && granite.pictos.split(':').includes(picto.id.toString()))}
          granite={granite}
          frameMode={frame && frame.mode}
          frameGraniteRef={frameGranite}
          pattern={true}
          selected={selectedGranite}
          disabledAccessory={
            disabledGranitesByAccessories.indexOf(granite.reference) >= 0
          }
          disabledHeadstone={
            availableGranitesByHeadstone &&
            availableGranitesByHeadstone.indexOf(granite.reference) < 0
          }
          onSelectGranite={() => this.onSelectGranite(granite, index)}
          // price={this.props.price}
          config={this.props.configuration}
          hoverInfo={this.props.hoverInfo}
          onClickDisableGranite={() =>
            this.onClickDisableGranite(granite, 'oui')
          }
          fromFamily={this.props.family}
          withAccessories={!this.props.family}
          color={this.state.color}
          price={price}
          loadingPrice={loadingPrice}
          showPrice={showPrice}
        />
      )
    }

  render() {
    const t = this.context;
    const { granites, matchcolors, configuration, accessories, headstones, filter, family, isFamily } = this.props;
    const { monument,bicolorMonument } = configuration
    let hideGranites = []

    // let availableGranites = _.filter(granites, 'available')
    let availableGranites = _.filter(granites, 'available').sort((a, b) => b.poids - a.poids).map((granite) => {
      const modifiedName = !isFamily ? t(`config3d_granit_${granite.reference}`) : granite.name
      return { ...granite, name: modifiedName };
    });
    if (isFamily && bicolorMonument) {
      availableGranites = availableGranites.filter((granite) => granite.gs && granite.gs.reference === monument.graniteSecondary)
    }
    
    availableGranites = _.filter(
      availableGranites,
      graniteRef => {
        let graniteList = graniteRef.catalogs && graniteRef.catalogs.split(/[;,]/) || []
        const organizationCatalog = getOrganization().catalogs && getOrganization().catalogs.split(/[;,]/) || []
        if(organizationCatalog.length === 0 || graniteList.length === 0 ) return false 
        for(let i=0; i<graniteList.length; i++) {
          if (organizationCatalog.indexOf(graniteList[i]) !== -1) {
            return true
          }
        }
        return false

      }

    )

    // Available Granites Names to filter
    const availableGranitesNames =  availableGranites
    .filter((a, i) => availableGranites.findIndex(b => b.reference === a.reference) === i)
    .map((granite, index)  => ({ id:index, name:(granite.name?.toUpperCase()), name2:(granite.name?.toUpperCase().replace(/É|Ê|È|Ë/g, "E")) }));
    availableGranitesNames.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    });
    const maxWeight = availableGranites[0] && availableGranites[0].maxpoids;
    const theFilter = filter
      ? filter
      : this.state.currentFilter
      ? this.state.currentFilter
      : null
    if (theFilter) {
      availableGranites = availableGranites.filter(
        (granite) => {
          if (bicolorMonument) {
            const filter = !isFamily && !theFilter.includes("/") ? `${theFilter}/${theFilter}` : theFilter
            if (!isFamily) {
              if (this.state.fromMatchingColor) {
                return granite.colorGranite.includes(filter) && granite.reference === granite.gs?.reference
              } else {
                return granite.colorGranite.includes(filter)
              }
            } else {
              return  granite.colorGranite.includes(`${theFilter}/`)
            }
          } else  {
            return granite.colorGranite === theFilter
          }
        }
      )
    }
    const theFilterSearch = this.state.currentFilterSearch
      ? this.state.currentFilterSearch
      : null
    if (theFilter || theFilterSearch || this.state.resetFilter) {
      availableGranites = this.availableGranitesFiltred(theFilter, theFilterSearch, availableGranites)
    }
    const { adminConfig } = this.props
    if (
      adminConfig &&
      adminConfig.granitesToHide &&
      adminConfig.granitesToHide.length >= 0
    ) {
      hideGranites = adminConfig.granitesToHide.map((granite) => granite.value)
      availableGranites = availableGranites.filter(
        (granite) =>
          !hideGranites.some((hideGranite) => hideGranite === granite.reference)
      )
    }
    // const monumentGranite = _.find(granites, {
    //   reference: monument.graniteMain
    // })

    let monumentGranite = granites.find(granite => granite.reference === monument.graniteMain)
    if (bicolorMonument) {
      monumentGranite = granites.find(granite => granite.reference === monument.graniteMain && granite.gs?.reference === monument.graniteSecondary)
    }
    if (monumentGranite) {
      monumentGranite.name = !isFamily ? t(`config3d_granit_${monumentGranite.reference}`) : monumentGranite.name
    }

    const isMonumentMadeInFrance =
      monumentGranite && monumentGranite.madeInFrance
    let disabledGranitesByAccessories = []
    if (configuration.accessories.length) {
      // On test si au moins un accessoire possède un granit différent du monument.
      // Cependant, on ne peut pas distinguer le cas où NF a été positionné en fallback ou à la main
      const atLeastOneAccessoryWithDifferentGranite = _.filter(
        configuration.accessories,
        (accessory) => {
          let g = granites.find(gr => gr?.reference === accessory?.granite)
          if (g && g.madeInFranceAndImported) {
            return false
          }
          return accessory?.granite && accessory?.granite !== monument.graniteMain
        }
      ).length

      // Si l'accessoire peut être frabriqué en france ou import
      const accessoriesWithoutFFIM =_.filter(accessories, a => {
        if (a.granites){
          let gdefault = a.granites.find(gr => gr.id === a.granite)
          if(gdefault && gdefault.madeInFranceAndImported) {
            return false
          }
        }
        return true
      })

      // Pour ne pas calculer cette intersection pour chaque granit, on la construit la première fois puis on la conserve.
      let granitesAvailableOnAllAccessories
      disabledGranitesByAccessories = _.chain(availableGranites)
        .filter(({ reference, madeInFrance }) => {
          // FR  => FR  : il faut vérifier que les accessoires sans granite sont compatibles avec ce granit
          // FR  => NFR : Si au moins un accessoire a un granit, on bloque sinon ok car fallback sur NF.
          // NFR => NFR : OK (fallback sur NF)
          // NFR => FR  : Si au moins un accessoire a un granit, on bloque.
          //              Sinon on vérifie que tous les accessoires sont compatibles avec ce granit

          if (accessoriesWithoutFFIM.length === 0) {
            // Si l'accessoire peut être fabriqué en france ou import
            return false
          }

          if (
            madeInFrance !== isMonumentMadeInFrance &&
            atLeastOneAccessoryWithDifferentGranite
          ) {
            // Si on passe de FR à non FR ou inversement et qu'au moins un accessoire
            // a un granite de spécifié (ie différent du monument), on bloque ce granit
            return true
          }

          if (!madeInFrance) {
            // C'est un granit non FR. Au pire, s'il n'est pas compatible avec l'un des accessoires,
            // on fallback sur Noir fin.
            return false
          }

          if (!granitesAvailableOnAllAccessories) {
            granitesAvailableOnAllAccessories = _.intersection(
              ..._.chain(accessoriesWithoutFFIM)
                .map('granites')
                .map((granites) => _.map(granites, 'reference'))
                .value()
            )
          }
          return granitesAvailableOnAllAccessories.indexOf(reference) < 0
        })
        .map('reference')
        .value()
    }
    //Place main granite on top
    // !(bicolorMonument && (theFilter || theFilterSearch))
    if (!(bicolorMonument && theFilter)) {
      availableGranites = availableGranites.filter((elt) => {
        const graniteMain = elt.reference !== monument.graniteMain
        return  bicolorMonument && !isFamily ? 
        graniteMain && elt.reference !== monument.graniteSecondary : graniteMain
      })
    }
    
    if (theFilter && !isFamily) {
      availableGranites = availableGranites
      .sort((g1,g2) => g1.gs && g2.gs ? g1.gs.colororder - g2.gs.colororder : true)
      .sort((g1,g2) => g1.colororder - g2.colororder)
    } else if(bicolorMonument && !isFamily && !theFilterSearch) {
      if(this.state.defaultgranites.length > 0){
        availableGranites = this.state.defaultgranites.filter(granite => granite && !(granite.reference === monumentGranite.reference && granite.gs?.reference === monumentGranite.gs?.reference))
                                                      .slice(0,74)
      } else {
        availableGranites = defaultBicolorGranites(availableGranites, matchcolors)
      }
    }
    availableGranites.unshift(monumentGranite)
    this.currentAvailableGranites = availableGranites;
    const availableGranitesByHeadstone =
      headstones && headstones.length
        ? _.map(
            (
              _.find(headstones, { reference: monument.headstone.reference }) ||
              {}
            ).granites,
            'reference'
          )
        : null
    
    const overlayClass =
      this.props.configuration.configType === 'family'
        ? 'CatalogModalOverlay Family'
        : 'CatalogModalOverlay'
    const { currentFilter, currentFilterSearch, fromMatchingColor, selectedGranite } = this.state
    let addPlus = true;
    let availableGranitesLength;
    const filterCurrent = currentFilter || this.props.filter
    // const filterCurrentSearch = currentFilterSearch || this.props.filter

    // && theFilter === null
    if(!this.state.currentFilterSearch && !family){
      if(!this.state.filter_list.includes(filterCurrent)){
        addPlus = false;
        if(availableGranites.length > availableGranites.filter(granite => granite && granite.poids ? granite.poids <= granite.maxpoids : true).length && (!this.state.isallgranites || !addPlus)){
          availableGranitesLength = availableGranites.filter(granite => granite && granite.poids <= granite.maxpoids).length;
          availableGranites = availableGranites.filter(granite=> granite && 
                              !hideGranites.some(hideGranite=>hideGranite === granite.reference)  
                              && granite.poids <= granite.maxpoids 
                              && granite.reference !== monument.graniteMain)
          availableGranites.push({reference: 0,poids: 0,maxpoids: maxWeight})
          availableGranites.unshift(monumentGranite)
    
        }
      }
    }
    availableGranites = availableGranites.filter(g=> g.isMon)
    const displayMessage = bicolorMonument && !family && !theFilter && !theFilterSearch && this.state.maxgranites > 75
    let buttonContent = !isFamily ? t("config3d_granit_button_monument") : "Monument";
    const seeMoreCombinations = !isFamily ? t("productmodal_multigranit_bicolor-see-more-combinations") : ""
    let buttontitle = !isFamily ? t("config3d_granit_modal_monument_title") : "Choisissez un granit à appliquer sur tout le monument"
    let buttonIcon = "monument3-icon monuments-icon"

    if (monument.category && monument.category === "SEM&PLT") {
      buttonContent = !isFamily ? t("config3d_actionbuttons_granittoggle") : "Granits"
    }
    else if (monument.category && monument.category.includes("SEM")) {
      buttontitle = !isFamily ? t("config3d_granit_modal_frame_title") : "Choisissez un granit à appliquer sur la semelle"
      buttonIcon = "frame-icon"
      buttonContent = !isFamily ? t("config3d_granit_button_frame") : "Semelle"
    } else if (monument.category && monument.category.includes("PLT")) {
      buttontitle = !isFamily ? t("config3d_granit_modal_veneer_title") : "Choisissez un granit à appliquer sur le placage"
      buttonIcon = "veneer-icon"
      buttonContent = !isFamily ? t("config3d_granit_button_veneer") : "Placage"
    }
    const showPrice = !this.props.family 
                      && userCan.seeAndChangeSellingPrices() 
    return (
      <div className='MainButton'>
        <ModalButton
          ref={(_modal) => (this.modal = _modal)}
          buttonContent={buttonContent}
          openAtStart={this.props.isSmartphone}
          noModal={this.props.noModal}
          buttonIcon={buttonIcon}
          onModalClose={this.onModalClose}
          disabled={isConfigRequested()}
          buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover"
          className="buttonModal background-page"
          onClick={() => this.handleGranitsClick(availableGranites)}
          toggleSteps={this.props.toggleSteps}
          launchIntro={this.props.launchIntro}
          modalName={this.props.modalName}
        >
          <div className='CompleteGranitePicker'>
            {!this.props.noModal && (
              <div className='Header'>
                <div className='HeaderContainer'>
                  <h1 className='Headline'>
                    { buttontitle }
                  </h1>
                </div>
              </div>
            )}
            {!family && (
              <FgraniteColors
                filter={(value,value2, value3, value4) => {
                  if (value === null && value2 === null) {
                    this.setState({currentFilter: value, currentFilterSearch: value2, fromMatchingColor: value3, filtredGranites: false, resetFilter: true})
                  } else {
                    // this.setState({filtredGranites: false})
                    this.setState({ currentFilter: value, currentFilterSearch: value2, fromMatchingColor: value3, selectedGranite: value4, filtredGranites: false })
                  }
                }}
                family={this.props.family}
                currentColor={currentFilter}
                currentSearch={currentFilterSearch}
                selectedGranite = {selectedGranite}
                fromMatchingColor={fromMatchingColor}
                hideTitle={true}
                items={availableGranitesNames}
              /> 
            )}
            {!addPlus &&
                <ScrollListView
                  items={availableGranites}
                  renderItem={this.renderItem(
                    disabledGranitesByAccessories,
                    availableGranitesByHeadstone
                  )}
                  className='GlobalGranitePicker'
                  filtredGranites={this.state.filtredGranites}
                  filterValue={this.state.filterValue}
                  seeMore = {displayMessage}
                  seeMoreCombinations = {seeMoreCombinations}
                  prices={this.state.prices}
                  onScrollBatch={() => this.loadPrices(availableGranites)}
                  showPrice={showPrice}
                />
              }
            {addPlus &&
              
              <ScrollListView
                items={availableGranites.filter(
                  (granite) =>
                    !hideGranites.some(
                      (hideGranite) => hideGranite === granite.reference
                    )
                )}
                renderItem={this.renderItem(
                  disabledGranitesByAccessories,
                  availableGranitesByHeadstone
                )}
                className='GlobalGranitePicker'
                seeMore = {displayMessage}
                filtredGranites={this.state.filtredGranites}
                filterValue={this.state.filterValue}
                seeMoreCombinations = {seeMoreCombinations}
                prices={this.state.prices}
                onScrollBatch={() => this.loadPrices(availableGranites)}
                showPrice={showPrice}
              />
              
            }
            {this.props.carousel && (
              <Modal
                isOpen={
                  this.props.selected !== false &&
                  this.props.selected !== undefined &&
                  this.props.configuration.designType === 'A'
                }
                onRequestClose={this.props.closeModal}
                overlayClassName={overlayClass}
                className='CatalogModal'
              >
                <GraniteCarousel
                  granites={availableGranites.filter(
                    (granite) =>
                      !hideGranites.some(
                        (hideGranite) => hideGranite === granite.reference
                      )
                  )}
                  slideToShow={this.findGraniteIndex(
                    this.props.selected,
                    availableGranites
                  )}
                  ffooter={true}
                  ptext='Retour choix du granit'
                  previous={this.props.closeModal}
                  monument={monument}
                  next={(elt) => this.props.goNext(elt)}
                  ntext='Choisir ce granit'
                />
              </Modal>
            )}
            { !isQuote(this.props.configuration) && showPrice &&
            <div className="prices">
            <div className="btn-wrapper">
              <div className="cfg-switch btn-config">
                <label className=''>
                  <input 
                    type="checkbox" 
                    checked={this.state.showSellingPrices}
                    onChange={() => this.togllePrice()} />
                  <span className="euro"></span>
                </label>
              </div>
            </div>
            </div>
          }
          </div>
        </ModalButton>
        <ElemConfirm
          isOpen={this.state.showConfirm}
          className='ModalElemConfirm'
          centered={true}
          fade={true}
          title={'Confirmez votre choix'}
          message={
            'Le choix de ce granit va entraîner la suppression de certains accessoires. Cliquez sur CONTINUER pour confirmer votre choix.'
          }
          eventName={'confirm-delete-accessories'}
          data={{ granite: this.state._granite }}
        ></ElemConfirm>
      </div>
    )
  }
}

export const GlobalGranitePicker = connect(
  (state) => ({
    configuration: state.configurator.current.configuration,
    granites: state.configurator.current.options.granites,
    matchcolors: state.configurator.current.options.matchcolors,
    accessories: state.configurator.current.accessories,
    headstones: state.configurator.current.headstones,
    adminConfig: state.adminConfig.config,
    isFamily: Boolean(state.user.family)
  }),
  (dispatch) => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch)
  })
)(GlobalGranitePickerComponent)
